/**
 * Route-name ⇄ `activeTabView` mapping.
 *
 * `activeTabView` is a hard `v-if` / `v-show` gate for Review, Feedback,
 * Presentation, App, MyQuizAnswers and the Footer container. The mapping is a
 * pure function so it can be unit tested and shared by
 * `mixins/active-tab-sync.mixin.js` (writes the state) and
 * `mixins/app-nav.mixin.js` (navigates between tabs).
 */
export const ACTIVE_TAB = {
  SLIDE: 'slide',
  LOOKBACK: 'lookback',
  FEEDBACK: 'feedback',
  PROFILE: 'profile',
}

/**
 * @param {string} routeName a vue-router route name (`home`, `presentation`,
 *   `lookback`, `feedback`, `account`, `profile`) — or an `activeTabView` value,
 *   which the `?tab=` query param passes straight through.
 * @returns {string} the matching `activeTabView` value; `slide` for anything
 *   unrecognised, preserving the previous `default:` branch.
 */
export const getActiveTabByRouteName = (routeName) => {
  const lowercaseRouteName = String(routeName || '').toLowerCase()

  switch (lowercaseRouteName) {
    case 'home':
    case 'presentation':
      return ACTIVE_TAB.SLIDE
    case 'lookback':
      return ACTIVE_TAB.LOOKBACK
    case 'feedback':
      return ACTIVE_TAB.FEEDBACK
    case 'account':
    case 'profile':
      return ACTIVE_TAB.PROFILE
    default:
      return ACTIVE_TAB.SLIDE
  }
}

export default getActiveTabByRouteName
